import {IMAGES_INITIAL} from "./helpers";
import {useInView} from "framer-motion";
import {useResponsiveImage} from "./useResponsiveImage";
import {useRef, memo, useState, useEffect} from "react";
import s from './ImageContainer.module.css';

export const ImageContainer = memo((props) => {

  const {
    id = IMAGES_INITIAL,
    aspectRatio = '3/2',
    scaleFactor = 1,
    isBlur = true,
    isLoadingFon = true,
    style,
    refreshKey = undefined,
    objectFit = 'cover',
    isBlurVisible = true,
  } = props;

  const boxRef = useRef(null);
  const boxImageRef = useRef(null);

  const isInViewBox = useInView(boxRef, {amount: 0.1, once: true});

  const {mainUrl, blurUrl, errorUrl} = useResponsiveImage(id, boxRef, scaleFactor, refreshKey);

  const [isLoadingFonShow, setIsLoadingFonShow] = useState(isLoadingFon);
  const [isLoadedBlur, setIsLoadedBlur] = useState(false);

  const isBlurVisibleFinal = blurUrl && isBlurVisible; //isBlur

  useEffect(() => {
    if (!isBlurVisibleFinal) return;

    const img = new Image();
    img.src = blurUrl;
    img.onload = () => {
      setIsLoadingFonShow(false);
      setIsLoadedBlur(true)
    };
    img.onerror = () => {
      setIsLoadingFonShow(false);
      setIsLoadedBlur(true)
    };

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [isBlurVisibleFinal, blurUrl]);

  const handleImageLoad = () => {
    if (boxImageRef?.current?.style?.backgroundImage !== '') {
      boxImageRef.current.style.backgroundImage = '';
    }
  };

  const handleImageError = (event) => {
    boxImageRef.current.style.backgroundImage = '';
    event.target.src = errorUrl;
  };

  return (
    <div
      ref={boxRef}
      className={s.box}
      style={{
        aspectRatio,
        ...(isLoadingFonShow ? {background: 'var(--background-grey)'} : {}),
        ...style
      }}
    >
      {isLoadingFonShow && <div className="loading-fon"/>}
      <div
        ref={boxImageRef}
        className={s['box-img']}
        style={(isBlurVisibleFinal && isBlur)
          ? {
            backgroundImage: `url(${blurUrl})`,
            backgroundSize: objectFit,
          }
          : {}
        }
      >
        <img
          className={s.img}
          alt={''}
          src={(isInViewBox && isLoadedBlur) ? mainUrl : null}
          onLoad={handleImageLoad}
          onError={handleImageError}
          style={{objectFit, opacity: (isInViewBox && isLoadedBlur) ? 1 : 0}}
        />
      </div>
    </div>
  );
});